<template>
    <section class="mx-2 my-6" :aria-labelledby="goalTitleId">
        <div class="flex flex-col gap-4">
            <I18nT v-if="goal.target_date" keypath="developmentJourneys.goalCard.due" tag="p" class="scaffold-body-small text-ink-muted">
                <template #date>
                    <template v-if="previousTargetDate">
                        <del data-testid="development-goal-previous-target-date"><BaseDate :value="previousTargetDate" format="date-long" /></del>
                        <i class="bi bi-arrow-right mx-2 text-xs" aria-hidden="true"></i>
                    </template>
                    <BaseDate :value="goal.target_date" format="date-long" />
                </template>
            </I18nT>

            <BaseCard theme="default" padding="none" radius="lgr" elevated class="overflow-hidden">
                <div class="flex items-start gap-3 px-5 py-5 sm:px-6 sm:py-6">
                    <DevelopmentGoalHourglass class="mt-1 size-[22px] shrink-0" />
                    <div class="min-w-0 grow">
                        <div class="flex items-start gap-2">
                            <h2 :id="goalTitleId" class="title-body min-w-0 grow text-ink">{{ goal.title }}</h2>
                            <BaseChip v-if="label" size="2xs" class="mt-1 shrink-0">{{ label }}</BaseChip>
                        </div>
                        <p class="mt-2 body text-ink-muted">{{ goal.achievement_criteria }}</p>
                    </div>
                </div>
            </BaseCard>
        </div>
    </section>
</template>

<script setup lang="ts">
import BaseCard from "~vue/components/BaseCard.vue";
import BaseChip from "~vue/components/BaseChip.vue";
import BaseDate from "~vue/components/BaseDate.vue";
import DevelopmentGoalHourglass from "~vue/icons/DevelopmentJourneyHourglass.vue";
import type { DevelopmentGoalDraft } from "~vue/types/chat";
import { useId } from "vue";
import { I18nT } from "vue-i18n";

defineProps<{ goal: DevelopmentGoalDraft; label?: string; previousTargetDate?: string | null }>();
const goalTitleId = useId();
</script>
